import { coreConstants } from '@adc/ui-morpheus'

export const isValidEmail = email =>
  coreConstants.regex.EMAIL_SYNTAX.test(email)
